import { Box, Table, TableBody, TableRow, Skeleton } from "@mui/material";
import  StyledTableCell  from "./tableStyles";

interface ColumnDef<T> {
  key: keyof T | string;
  id: keyof T | string;
  label: string;
  width?: number;
  align?: "left" | "right" | "center";
  sortable?: boolean;
  fontSize?: string;
  truncate?: number;
  wrap?: boolean;
}

interface TableSkeletonProps<T> {
  columns: ColumnDef<T>[];
}

export default function TableSkeleton<T>({ columns }: TableSkeletonProps<T>) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 56, 
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ tableLayout: "fixed" }}>
        <TableBody>
          {Array.from({ length: 10 }).map((_, index) => (
            <TableRow key={index} sx={{ height: 48 }}>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id as string}
                  align={column.align || "left"}
                  style={{ width: column.width }}
                  fontSize={column.fontSize}
                >
                  <Skeleton variant="text" width="80%" />
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}